import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { requestViewPersonContracts } from '../../../api/contract/contract.actions';

import DealRoom from '../../../components/screens/shop/deal-room/DealRoom';

const DealRoomContainer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(requestViewPersonContracts());
  }, [dispatch]);

  return <DealRoom />;
};

export default DealRoomContainer;
